import React from 'react';
//import { createBrowserHistory } from 'history';
import { ThemeProvider } from 'styled-components';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'; //← Bridge React and Redux
import './index.css';
import App from './App';
import theme from 'theme'; //eslint-disable-line
import { store } from './store/configureStore';
import CalendarTabbar from './components/CalendarTabbar';
import { MainTabbarWrapper } from './components/CalendarTabbar/styles';
import { isFootballCup } from './common/rcs_gaz_mc_core_FE/build/config';

const { sportId, competitionId, playoff } = window.matchcenterPage;

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <MainTabbarWrapper>
        <CalendarTabbar
          isCup={isFootballCup(sportId, competitionId)}
          isFootballChampionship={sportId === '1' && competitionId === 21}
          isFootballSerieB={sportId === '1' && (competitionId === 105 || competitionId === 199)}
          isFootballExtChampionship={sportId === '1' && (competitionId === 8 || competitionId === 22 || competitionId === 23 || competitionId === 24 || competitionId === 112)}
          isMotorSport={sportId === '6M' || sportId === '6C'}
          isTennis={sportId === '8'}
          isCycling={sportId === '18'}
          isVolley={sportId === '5' && (competitionId === 34 || competitionId === 35 || competitionId === 53 || competitionId === 54)}
          isVolleyChampionship={sportId === '5' && (competitionId === 2 || competitionId === 3)}
          isBasketChampionship={sportId === '3' && (competitionId === 2 || competitionId === 5 || competitionId === 6 || competitionId === 7)}
          isBasketSerieA={sportId === '3' && competitionId === 1}
          isNba={sportId === '3' && competitionId === 3}
          isRugby={sportId === '2'}
        />
      </MainTabbarWrapper>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root-header'),
);
ReactDOM.render(
  <Provider store={store}>
    <App
      isCup={isFootballCup(sportId, competitionId)}
      isFootballSerieB={sportId === '1' && (competitionId === 105 || competitionId === 199)}
      isSpecial={playoff}
      isMotorSport={sportId === '6M' || sportId === '6C'}
      isTennis={sportId === '8'}
      isCycling={sportId === '18'}
      isVolley={sportId === '5' && (competitionId === 34 || competitionId === 35 || competitionId === 53 || competitionId === 54)}
      isVolleyChampionship={sportId === '5' && (competitionId === 2 || competitionId === 3)}
      isBasketChampionship={sportId === '3' && (competitionId === 2 || competitionId === 5 || competitionId === 6 || competitionId === 7)}
      isBasketSerieA={sportId === '3' && competitionId === 1}
      isNba={sportId === '3' && competitionId === 3}
      isRugby={sportId === '2'}
      isUefaCompetition={sportId === '1' && (competitionId === 5 || competitionId === 6 || competitionId === 1125 || competitionId === 259)}
    />
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js